<template>
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;">
    <v-flex xs6 class="inline-block px-4">
      <label>{{$t('Admin.User.Form.Name')}}:</label>&nbsp;<span>{{user.USR_NOM}}</span><br/>      
    </v-flex>
    <v-flex xs6 class="px-4" order-xs2>       
      
    </v-flex>
  </v-layout>        
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import Fiche from '@/components/admin/Fiche.vue'

  @Component({
    name: 'FicheUser'
  })
  export default class FicheUser extends Vue {  
    
    get user() {
      return this.$store.myGetters.originalAdmUser
    }
    
  }
</script>